import PageBase from '@glittr/frontend-core/src/core/v2/app/pageBase';
import DataSource from '@glittr/frontend-core/src/core/v2/data/data-source';
import Vue from 'vue';
import Int64LookupModel from '@glittr/frontend-core/src/services/v2/model/int64-lookup-model';
import LookupRequestModel from '../../../../services/v2/model/lookup-request-model';
import GuidEventLookupModel from '../../../../services/v2/model/guid-event-lookup-model';

export default class OrganisationAnalyticsPage extends PageBase {
  public adminMode: boolean = false;

  public get dataSource() { return this.adminAnalyticsDataSource; }

  public set dataSource(value) { /* Do nothing */ }

  public get adminAnalyticsList() {
    return this.adminAnalyticsDataSource.data?.items.map((i) => {
      return {
        companyName: i.data.companyName,
        companyId: i.data.companyId,
        countShowDetails: i.data.analytics?.countShowDetails,
        countAddToTour: i.data.analytics?.countAddToTour,
        countRemoveFromTour: i.data.analytics?.countRemoveFromTour,
        countDownloadTour: i.data.analytics?.countDownloadTour,
      };
    }) || [];
  }

  public set adminAnalyticsList(value) { /* Do nothing */ }

  public adminAnalyticsDataSource = new DataSource({
    selectCommand: Vue.$service.v2.api.tdg_Analytics.getAnalyticsForAdmin,
  });

  public eventsDataSource = new DataSource({
    selectCommand: () => {
      const req = new LookupRequestModel();
      return Vue.$service.v2.api.tdg_Events.eventLookup(req);
    },
  });

  public organisationsDataSource = new DataSource({
    selectCommand: () => {
      const req = new LookupRequestModel();
      req.eventIdentifier = this.eventsDataSource.filter.eventIdentifier;
      return Vue.$service.v2.api.tdg_Organisations.lookup(req);
    },
  });

  public organisationNameItems: Int64LookupModel[] | undefined;

  public eventItems: GuidEventLookupModel[] | undefined;

  async initialize(): Promise<void> {
    await this.eventsDataSource.select();
    await this.loadEventLookup();
    await this.organisationsDataSource.select();
    await this.loadOrganisationLookup();
    this.adminAnalyticsDataSource.filter.eventIdentifier = this.eventsDataSource.filter.eventIdentifier;
    await this.adminAnalyticsDataSource.select();
  }

  async refreshInitialize(): Promise<void> {
    await this.organisationsDataSource.select();
    await this.loadOrganisationLookup();
    await this.adminAnalyticsDataSource.select();
  }

  public companyColumns = [
    { value: Vue.$t('page.dashboard.adminAnalytics.table.companyName'), field: 'companyName' },
    { value: Vue.$t('page.dashboard.adminAnalytics.table.viewed'), textAlign: 'center', field: 'countShowDetails' },
    { value: Vue.$t('page.dashboard.adminAnalytics.table.tourAdded'), textAlign: 'center', field: 'countAddToTour' },
    { value: Vue.$t('page.dashboard.adminAnalytics.table.tourRemoved'), textAlign: 'center', field: 'countRemoveFromTour' },
    { value: Vue.$t('page.dashboard.adminAnalytics.table.tourDownloaded'), textAlign: 'center', field: 'countDownloadTour' },
    { value: '', field: 'actions' },
  ];

  gotoDetail(id: string | number) {
    Vue.$router.push(`/_admin/analytics/${id}`);
  }

  async refreshAnalytics() {
    try {
      await this.refreshInitialize();
    } catch (error) {
      Vue.$log.error(`Error refreshing companies: ${error}`);
    }
  }

  async loadOrganisationLookup() {
    try {
      if (this.organisationsDataSource.data) {
        const res = this.organisationsDataSource.data;
        this.organisationNameItems = res.items.map((i: { data: any; }) => i.data);
      }
    } catch (error) {
      Vue.$log.error('Failed to load organisations:');
    }
  }

  async loadEventLookup() {
    if (this.eventsDataSource.data) {
      const res = this.eventsDataSource.data;

      this.eventItems = res.items.map((i) => {
        const model = new GuidEventLookupModel();
        model.id = i.data.id;
        model.caption = i.data.caption;
        return model;
      });

      if (this.eventItems.length > 0) {
        const lastItem = this.eventItems[this.eventItems.length - 1];
        this.eventsDataSource.filter.eventIdentifier = lastItem.id;
      }
    }
  }
}
